var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('login-form',[_c('img',{staticClass:"logo",attrs:{"src":require('@images/logo_black.png')}}),_c('div',{staticClass:"login-header"},[_vm._v(" "+_vm._s(_vm.$t('login.header'))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }